import * as string from "./string.js";
export const eventBaseId = (id) => string.leftOfBack("_", id) || id;
